<template>
  <div class="nav-sidebar flex-column align-items-center justify-content-center position-relative">
    <div class="position-relative nav-steps">
      <div class="nav-step d-flex flex-column align-items-center">
        <div class="nav-step-icon d-flex align-items-center justify-content-center fs-14" :class="{ 'nav-step-icon--active bg-blue' : step === 1, 'bg-green nav-step-icon--done' : step > 1 }">
          <i class="icon-plane color-white"></i>
        </div>
        <p class="text-uppercase color-white fs-12 mb-0 mt-2 font-smoothing">Booking</p>
      </div>
      <div class="nav-step d-flex flex-column align-items-center">
        <div class="nav-step-icon d-flex align-items-center justify-content-center fs-14" :class="{ 'nav-step-icon--active bg-blue' : step === 2, 'bg-green nav-step-icon--done' : step > 2 }">
          <i class="icon-briefcase color-white"></i>
        </div>
        <p class="text-uppercase color-white fs-12 mb-0 mt-2 font-smoothing">Bagage</p>
      </div>
      <div class="nav-step d-flex flex-column align-items-center">
        <div class="nav-step-icon d-flex align-items-center justify-content-center fs-14" :class="{ 'nav-step-icon--active bg-blue' : step === 3, 'bg-green nav-step-icon--done' : step > 3 }">
          <i class="icon-user color-white"></i>
        </div>
        <p class="text-uppercase color-white fs-12 mb-0 mt-2 font-smoothing">Kontakt</p>
      </div>
      <div class="nav-step d-flex flex-column align-items-center">
        <div class="nav-step-icon d-flex align-items-center justify-content-center fs-14" :class="{ 'nav-step-icon--active bg-blue' : step === 4, 'bg-green nav-step-icon--done' : step > 4 }">
          <i class="icon-wallet color-white"></i>
        </div>
        <p class="text-uppercase color-white fs-12 mb-0 mt-2 font-smoothing">Betaling</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavSidebar',
  props: {
    step: { type: Number, required: true }
  }
}
</script>

<style lang="scss" scoped>
  @use '../assets/scss/variables' as *;
  @use '../assets/scss/media-queries' as *;
  
  .nav-sidebar {
    width: 240px;
    background: url('../assets/images/bg-front.jpg') 50% center / cover no-repeat;
    display: flex;

    @include max-screen(1200px) {
      display: none;
    }

    &::after {
      content: '';
      background: rgba(47,59,80,0.7);
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .nav-steps {
      z-index: 1;

      .nav-step:first-child {
        margin-top: 30px;
      }

      .nav-step {
        margin-bottom: 30px;
        

        .nav-step-icon {
          border-radius: 50%;
          width: 30px;
          height: 30px;
          border: 1px dashed #fff;

          &--active {
            border: 1px solid $blue;
          }

          &--done {
            border: 1px solid $green;
          }
        }
      }
    }
  }
</style>
